
import { defineComponent, computed } from "vue";

export default defineComponent({
  name: "EconomySection",
  props: {
    economy: { type: Object, required: true },
    loading: { type: Boolean, default: false },
    loaded: { type: Boolean, default: false },
    error: { type: String, default: null },
  },
  setup(props) {
    const donutSeries = computed(() =>
      (props.economy.coinsIn ?? []).map((x: any) => Number(x.value))
    );
    const donutOptions = computed(() => ({
      chart: { background: "transparent" },
      labels: (props.economy.coinsIn ?? []).map((x: any) => x.name),
      legend: { position: "bottom", labels: { colors: "#fff" } },
      tooltip: { theme: "dark" },
      dataLabels: { enabled: false },
    }));

    const lineSeries = computed(() => [
      { name: "Net coins", data: (props.economy.netPerDay ?? []).map((p: any) => p.value) },
    ]);
    const lineOptions = computed(() => ({
      chart: { toolbar: { show: false }, background: "transparent" },
      stroke: { curve: "smooth", width: 2 },
      xaxis: {
        categories: (props.economy.netPerDay ?? []).map((p: any) => p.date.slice(0, 10)),
        labels: { style: { colors: "#fff" } },
      },
      yaxis: { labels: { style: { colors: "#fff" } } },
      tooltip: { theme: "dark" },
      dataLabels: { enabled: false },
      colors: ["#F50242"],
    }));

    return { donutSeries, donutOptions, lineSeries, lineOptions };
  },
});
